import { type ElementType, type ReactNode } from "react";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Box } from "ui/box";
import { mergeSx } from "ui/merge-sx";

interface PageContentHeaderProps {
  component?: ElementType;
  className?: string;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const PageContentHeader = ({
  component = "div",
  className,
  children,
  sx,
}: PageContentHeaderProps) => (
  <Box
    component={component}
    data-testid="page-content-header"
    className={className}
    sx={mergeSx(
      {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mx: "auto",
        my: 2,
        width: "100%",
        mt: "0!important",
      },
      sx,
    )}>
    {children}
  </Box>
);

export default PageContentHeader;
